import { Stack, SxProps, useTheme } from '@mui/material';
import { FC } from 'react';
import { ValidationError } from '@/types/validation';
import ErrorBadge from './ErrorBadge';

type ErrorBadgesProps = {
  errors: ValidationError[];
};

const ErrorBadges: FC<ErrorBadgesProps> = (props) => {
  const theme = useTheme();

  const infos = props.errors?.filter((validation) => validation.severity === 'info');
  const warnings = props.errors?.filter((validation) => validation.severity === 'warning');
  const errors = props.errors?.filter((validation) => validation.severity === 'error');

  return (
    <Stack
      direction='row'
      sx={{
        color: theme.palette.text.primary,
        justifyContent: 'end',
        alignItems: 'center',
        height: '100%'
      }}
    >
      {!!infos?.length && <ErrorBadge severity='info' label={infos.length.toString()} />}
      {!!warnings?.length && <ErrorBadge severity='warning' label={warnings.length.toString()} />}
      {!!errors?.length && <ErrorBadge severity='error' label={errors.length.toString()} />}
    </Stack>
  );
};

export default ErrorBadges;
